import { Component, OnDestroy, OnInit } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { ApiService, TrackingService } from "../../services/service.index";
import { AuthService } from "../../services/service.index";
import { ActivatedRoute, Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { ToastrService } from 'ngx-toastr';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/app.reducer';
import { FineModel } from 'src/app/store/fine.model';
import { PersistFineService } from 'src/app/services/persist.fine.service';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { Location } from '@angular/common';

/**
 * After the payment fine, to show error in payment process
 *
 * @author Fran Aragon
 */
@Component({
    selector: 'app-payerror',
    templateUrl: './payerror.component.html',
    styles: []
})
export class PayerrorComponent implements OnInit, OnDestroy {

    /**
     * Session hash
     */
    private hash: string;

    /**
     * Param hash
     */
    private param_hash: string;

    /**
     * checksesInterval
     */
    private checksesInterval: any;

    private subscription: Subscription = new Subscription();

    private fineObject: FineModel;

    /**
     * @ignore
     */
    constructor(private http: HttpClient,
                private router: Router,
                private route: ActivatedRoute,
                private apiService: ApiService,
                private authService: AuthService,
                private translate: TranslateService,
                private trackingService: TrackingService,
                private toastr: ToastrService,
                private store: Store<AppState>,
                private persistFineService: PersistFineService,
                private location: Location) {

        this.persistFineService.loadData();

        this.hash = this.authService.getHash();

        this.route.params.subscribe(params => {
            this.param_hash = params['hash'];
        });
    }

    /**
     * @ignore
     */
    ngOnInit() {

        // if session hash is different from hash of route eject from session to login page.
        if (this.hash != this.param_hash) {
            this.authService.logout();
            this.router.navigate([`/app/login/pyf/${this.hash}`]);
            const errMsg: any = this.translate.instant('LoginPage.ExpiredSession');
            this.toastr.error(errMsg);
            return false;
        }

        this.checksesInterval = setInterval(() => {
            this.hash = this.authService.getHash();
            if (this.hash != this.param_hash) {
                this.authService.logout();
                this.router.navigate([`/app/login/pyf/${this.param_hash}`]);
                const errMsg: any = this.translate.instant('LoginPage.ExpiredSession');
                this.toastr.error(errMsg);
                clearInterval(this.checksesInterval);
                return false;
            }

        }, 1000 * 60);

        this.subscription = this.store.select('fine_state')
            .pipe(filter(fine_state => fine_state.fine != null))
            .subscribe(fine_state => {
                this.fineObject =  new FineModel({
                    rolAcceso: fine_state.fine.rolAcceso,
                    rolPermiso: fine_state.fine.rolPermiso,
                    acceso: fine_state.fine.acceso,
                    cliente: fine_state.fine.cliente,
                    contrato: fine_state.fine.contrato,
                    fechaInicioContrato: fine_state.fine.fechaInicioContrato,
                    fechaFinContrato: fine_state.fine.fechaFinContrato,
                    expedienteGesthispania: fine_state.fine.expedienteGesthispania,
                    nombreOrganismo: fine_state.fine.nombreOrganismo,
                    codigoSancion: fine_state.fine.codigoSancion,
                    lugar: fine_state.fine.lugar,
                    matricula: fine_state.fine.matricula,
                    tipoInfraccion: fine_state.fine.tipoInfraccion,
                    estado: fine_state.fine.estado,
                    fechaFinEnlace: fine_state.fine.fechaFinEnlace,
                    importeAPagar: fine_state.fine.importeAPagar,
                    importePagado: fine_state.fine.importePagado,
                    idEnlace: fine_state.fine.idEnlace,
                    pagoActivo: fine_state.fine.pagoActivo,
                });

            });


        this.myInitEvent();
    }

    /**
     * @ignore
     */
    ngOnDestroy() {
        clearInterval(this.checksesInterval);
        this.subscription.unsubscribe();
    }

    /**
     * Redirects to data fine route
     */
    redirect() {
        this.router.navigate([`app/viewfine/${this.hash}`]);
    }

    /**
     * Captures component event and sends event data to analytics.
     */
    myEvent(event) {
        if(this.trackingService.getPermissionTracking() == 'all' || this.trackingService.getPermissionTracking() == 'statistics'){

            this.trackingService.setHash(this.hash);

            this.trackingService.actionEvent(event, 'RETURN_TPV');

            // Google Analytics
            let idElement: string = (event.target as Element).id;
            let typeEvent: string = event.type;
            let eventAction: string = "idelement: "+idElement+" - typeEvent: "+typeEvent;
            // (<any>window).ga('send', 'event', {
            //     eventCategory: 'Pay Tpv error Page Events',
            //     eventLabel: 'PayTpvErrorPageEvents',
            //     eventAction: eventAction,
            //     eventValue: 10
            // });
        }

    }

    /**
     * Captures init component event and sends event data to analytics.
     */
    myInitEvent() {
        if(this.trackingService.getPermissionTracking() == 'all' || this.trackingService.getPermissionTracking() == 'statistics'){

            this.trackingService.setHash(this.hash);

            this.trackingService.returnTPVEvent("pay-tpv-error", 'RETURN_TPV');

            // Google Analytics
            // (<any>window).ga('send', 'event', {
            //     eventCategory: 'Pay Tpv error',
            //     eventLabel: 'PayTpvError',
            //     eventAction: 'Pay Tpv error',
            //     eventValue: 10
            // });
        }

    }

    viewFine() {
        const hash = this.authService.getHash();
        this.router.navigate([`app/finegroup/${hash}`]);
        // if (JSON.parse(localStorage.getItem('expedientes')).length > 1) {
        //     this.router.navigate([`app/finegroup/${hash}`]);
        // } else {
        //     this.router.navigate([`app/viewfine/${hash}`]);
        // }
    }

}
